/**
 * submit-answers-upstream-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { IntakeAnswer } from "../../../algorithms/structure/intake-answer";
import { Message } from "../general/message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link SubmitAnswersUpstreamMessage} when it wishes to
 * feed newly-obtained state variable values back to the server. If the server
 * encounters an unexpected error during processing of the answers, then it
 * replies with a negative {@link AcknowledgmentResponse}. Otherwise the server
 * replies with a positive acknowledgment. Eventually the server may send {@link
 * NextStepsResponse}s that identify the next {@link IntakeStep}s and {@link
 * ReportStep}s to present.
 */
export class SubmitAnswersUpstreamMessage extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.UP_SUBMIT_ANSWERS;
	public static tag : MessageTag = MessageTag.UP_SUBMIT_ANSWERS;

  public expectsReply () : boolean
  {
    // NextAnswersMessage technically expects an acknowledgment message...
    return true;
  }

  /**
   * Construct a new {@link SubmitAnswersUpstreamMessage}.
   *
   * @param answers
   *        The {@link IntakeAnswer}s.
   */
  constructor (public answers : IntakeAnswer[])
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/submit-answers-upstream-message.ts